import { CashierManagementDepositComponent } from './../cashier-management-deposit/cashier-management-deposit.component';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { SubheaderService } from 'src/app/core/_base/layout';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { CashierManagementStatusEnum } from '../../enum/cashier-management-status.enum';
import { CashierManagementParams } from '../../models/cashier-management-params.model';
import { CashierManagement } from '../../models/cashier-management.model';
import { CashierManagementService } from '../../services/cashier-management.service';
import { AppConfig } from 'src/app/core/_config/app.config';
import { DOCUMENT } from '@angular/common';
import { CashierManagementTransferBatchComponent } from '../cashier-management-transfer-batch/cashier-management-transfer-batch.component';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { DownloadedFile } from '../../../file-remitance/models/downloadFile';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'kt-cashier-management',
    templateUrl: './cashier-management.component.html',
    styleUrls: ['./cashier-management.component.scss'],
    providers: [CashierManagementService],
    encapsulation: ViewEncapsulation.None,
})
export class CashierManagementComponent implements OnInit {
    public resOk: boolean;
    public lines: any[] = [];
    public canTransferBatch: boolean = false;

    public cashierManagemenrParams: CashierManagementParams;

    simpleTableConfig: SimpleListConfig = {
        useSortable: true,
        useFilter: false,
        usePagination: true,
        pageSize: [15, 20, 30],
        dateformat: 'dd/MM/yyyy',
        displayColumns: [
            {
                displayName: 'CASHIERMANAGEMENT.dateOpen',
                field: 'dateOpen',
                type: 'date',
            },
            {
                displayName: 'CASHIERMANAGEMENT.dateClose',
                field: 'dateClose',
                type: 'date',
            },
            {
                displayName: 'CASHIERMANAGEMENT.user',
                field: 'userName',
            },
            {
                displayName: 'CASHIERMANAGEMENT.numberCasher',
                field: 'numberCasher',
            },
            {
                displayName: 'CASHIERMANAGEMENT.entity',
                field: 'entityDescription',
            },
            {
                displayName: 'CASHIERMANAGEMENT.payment',
                field: 'paymentTotal',
                type: 'currency',
            },
            {
                displayName: 'CASHIERMANAGEMENT.receipt',
                field: 'receivingTotal',
                type: 'currency',
            },
            {
                displayName: 'CASHIERMANAGEMENT.toDeposit',
                field: 'toDeposit',
                type: 'style-with-action-currancy',
                action: (a) => this.onSelectToDeposit(a),
                style: (a) => this.styleToDeposit(a),
            },
            {
                displayName: 'CASHIERMANAGEMENT.accounted',
                field: 'accounted',
                type: 'icon-done-done-all',
            },
            {
                field: 'action',
                type: 'action',
            },
        ],
        lineActions: [
            {
                action: (a) => this.onSelectToTransferBatch(a),
                label: this._translate.instant('CASHIERMANAGEMENT.transfer_cashier'),
                color: 'primary',
                icon: 'swap_horiz',
                disabled: (a) => this.canBatchBeTransferred(a),
            },
            {
                action: (a) => this.onSelectToSearch(a),
                label: this._translate.instant('CASHIERMANAGEMENT.search'),
                color: 'primary',
                icon: 'search',
            },
            {
                action: (a) => this.onSelectToPrint(a),
                label: this._translate.instant('CASHIERMANAGEMENT.print'),
                color: 'primary',
                icon: 'print',
                disabled: (a) => this.canPrint(a),
            },
        ],
        page: {
            totalElements: 0,
            index: 0,
            size: 0,
        },
    };

    public range = new FormGroup({
        dateOpen: new FormControl({ value: '', disabled: true }),
        dateClose: new FormControl({ value: '', disabled: true }),
    });

    public cashierManagementStatusEnum: typeof CashierManagementStatusEnum = CashierManagementStatusEnum;
    public cashierManagementStatusEnumArray = Object.keys(CashierManagementStatusEnum).slice(
        Object.keys(CashierManagementStatusEnum).length / 2,
    );

    constructor(
        public _loaderService: LoaderService,
        public _subheaderService: SubheaderService,
        private _cdRef: ChangeDetectorRef,
        private _cashierManagementService: CashierManagementService,
        private _dialog: MatDialog,
        private _config: AppConfig,
        @Inject(DOCUMENT) readonly document: Document,
        private _translate: TranslateService,
    ) {
        _subheaderService.setTitle('Gerenciar Caixas');
        this.cashierManagemenrParams = new CashierManagementParams();
        this.canTransferBatch = false;
    }

    ngOnInit(): void {
        this.getCanTransferBatch();
    }

    public onSearch(): void {
        this.resOk = false;
        this._loaderService.show();
        this._cdRef.detectChanges();

        this._cashierManagementService.getCashierManagement(this.cashierManagemenrParams).subscribe((result) => {
            this._loaderService.hide();
            if (result.success) {
                this.lines = result.data.result;
                this.simpleTableConfig.page.index = result.data.currentPage - 1;
                this.simpleTableConfig.page.totalElements = result.data.totalRecords;
                this.resOk = true;
                this._cdRef.detectChanges();
            }
        });
    }

    public onExportData(): void {
        this.resOk = false;
        this._loaderService.show();
        this._cdRef.detectChanges();

        this._cashierManagementService.GetCashierTable(this.cashierManagemenrParams)
        .subscribe((result) => {
            this._loaderService.hide();

             var binaryData = atob(result.data);
             
             const blob = new Blob([new Uint8Array(binaryData.length)
                .map((_, index) => binaryData.charCodeAt(index))], 
                {      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'    });
                     const url = window.URL.createObjectURL(blob);     
                      const a = document.createElement('a');   
                       a.href = url;    
                       a.download = result.fileDownloadName; 
                        a.click();     
                        window.URL.revokeObjectURL(url);

        });
    }

    public onCleanFilter(): void {
        this.cashierManagemenrParams = new CashierManagementParams();

        this.range.patchValue({ dateOpen: '', dateClose: '' });
    }

    public onReloadTable(ev: any): void {
        this.cashierManagemenrParams.itemsPage = ev.pageSize;
        this.cashierManagemenrParams.currentPage = ev.pageIndex + 1;
        this.simpleTableConfig.page.size = ev.pageSize;

        this.onSearch();
    }

    public onRangeDateApply() {
        this.cashierManagemenrParams.dateOpenStart = this.range.value.dateOpen?.toJSON();
        this.cashierManagemenrParams.dateOpenFinal =
            this.range.value.dateClose?.toJSON() ?? this.cashierManagemenrParams.dateOpenStart;
    }

    private styleToDeposit(element: CashierManagement): any {
        return {
            cursor: element.toDeposit > 0 && element.accounted ? 'pointer' : 'default',
            color: element.toDeposit > 0 && element.accounted ? '#ffffff' : '',
            'background-color': element.toDeposit > 0 && element.accounted ? '#3699ff' : '',
            'border-radius': element.toDeposit > 0 && element.accounted ? '5px' : '',
            padding: element.toDeposit > 0 && element.accounted ? '5px' : '',
        };
    }

    private onSelectToDeposit(element: CashierManagement): void {
        if (element.toDeposit > 0 && element.accounted) {
            const dialogRef = this._dialog.open(CashierManagementDepositComponent, {
                data: { cashier: element },
                minWidth: '600px',
                disableClose: true,
                autoFocus: true,
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.onSearch();
                }
            });
        }
    }

    private onSelectToPrint(element: CashierManagement): void {
        if (element.accounted) {
            this.redirect(`${this._config.urlOldAfs}Cashiers/Batch/Print?batchId=${element.batchId}`);
        }
    }

    get window(): Window {
        return this.document.defaultView;
    }

    private onSelectToSearch(element: CashierManagement): void {
        this.redirect(`${this._config.urlOldAfs}Cashiers/Batch/BatchDetail?batchId=${element.batchId}`);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!this.window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }

    private getCanTransferBatch() {
        this._cashierManagementService.canTransferBatch().subscribe((result) => {
            this._loaderService.hide();
            if (result.success) {
                this.canTransferBatch = result.data;
            }
        });
    }

    private canBatchBeTransferred(element: CashierManagement): boolean {
        return !element.accounted && element.dateClose === null && this.canTransferBatch;
    }

    private canPrint(element: CashierManagement): boolean {
        return !!element.dateClose;
    }

    private onSelectToTransferBatch(element: CashierManagement): void {
        const dialogRef = this._dialog.open(CashierManagementTransferBatchComponent, {
            data: { cashier: element },
            maxWidth: '400px',
            disableClose: true,
            autoFocus: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.onSearch();
            }
        });
    }
}
